import { render, staticRenderFns } from "./BrandCookies.vue?vue&type=template&id=21c53906&scoped=true&"
import script from "./BrandCookies.vue?vue&type=script&lang=js&"
export * from "./BrandCookies.vue?vue&type=script&lang=js&"
import style0 from "./BrandCookies.vue?vue&type=style&index=0&id=21c53906&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21c53906",
  null
  
)

export default component.exports